<template>
	<div
		id="planning-form"
		class="d-lg-flex flex-column w-100 px-3 pb-2 p-lg-3 pt-lg-4"
	>
		<div class="d-flex flex-column flex-lg-row gap-1">
			<div
				class="d-flex flex-column nowrap align-items-start col-12 col-md-12 col-lg-6 px-0 mt-3"
			>
				<div class="me-lg-3 col-md-12 col-12">
					<DatePicker/>
				</div>
			</div>
			<div class="col-12 col-md-12 col-lg-6 px-0 mt-3">
				<div class="ml-lg-3">
					<Participants
						@changeOpenParticipants="
							(bool) => handleChangeOpenParticipants(bool)
						"
						@setParticipants="(newArray) => handleSetParticipants(newArray)"
						@notEnoughAdults="handleNotEnoughAdults"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// components
import Participants from "@/vue/planning/components/search/participants.vue";
import DatePicker from "@/vue/planning/components/search/flight/flightDatePicker.vue";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "Form",
	components: {
		Participants,
		DatePicker,
	},
	methods: {
		handleDatepickerOpenStateChange(str) {
			this.$store.dispatch("setDatepickerOpen", str);
		},
		handleChangeOpenParticipants(bool) {
			this.$store.dispatch("setParticipantsDropdownOpen", bool);
		},
		handleSetParticipants(newArray) {
			this.$store.dispatch("setParticipants", newArray);
		},
		handleNotEnoughAdults() {
			this.$store.commit(
				"setErrorMessageOpen",
				"errorMessages_notEnoughAdults"
			);
		},
	},
};
</script>

<style scoped></style>
